<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showBroadcastMessageCreateSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'840px'}">
    <ng-template pTemplate="header">
        <div class="bm-header-title">Create Broadcast Messages to {{getTitle(broadcastUserType)}}</div>
        <div class="sidebar-header-sub-title"></div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">

        <div class="bm-tab-height bx-pager bx-default-pager">
            <div class="bx-pager-item" [class]="'active'" style="flex: 0 50% !important;"
                 (click)="activeMenuTab = menuTab.Details">
                <a class="bm-tab-title bx-pager-link" data-slide-index="0">Details
                    <div class="bm-font-14">Information about the message</div>
                </a>
                <div class="bm-arrow arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class]="(activeMenuTab === menuTab.Message) ? 'active' : ''"
                 style="flex: 0 50% !important;" (click)="activeMenuTab = menuTab.Message">
                <a class="bm-tab-title bx-pager-link" style="margin-left: 30px" data-slide-index="1">Message
                    <div class="bm-font-14">Compose a message</div>
                </a>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Details">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 284px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="bm-provide p-2">Please provide some details</div>

                <div class="flex flex-row">
                    <div class="col-6 p-3">
                        <div class="bm-label">Channel</div>
                        <p-dropdown placeholder="Select Channel Type" [(ngModel)]="broadcastMessage.BroadcastChannelType" [options]="broadcastChannelTypeList"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                    <div class="col-6 p-3">
                        <div class="bm-label">Broadcast Date and Time</div>
                        <p-calendar [(ngModel)]="broadcastMessage.BroadcastStartDateTime" [showTime]="true" [showSeconds]="true" [minDate]="today"
                                    [showIcon]="true" placeholder="Select date"
                                    [style]="{'width': '100%'}"></p-calendar>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="p-3" [ngClass]="(showFieldDay(broadcastMessage.BroadcastReceiverType)) ? 'col-4': 'col-6'">
                        <div class="bm-label">Receiver Type</div>
                        <p-dropdown placeholder="Select Receiver Type" [(ngModel)]="broadcastMessage.BroadcastReceiverType" [options]="broadcastReceiverTypeList"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                    <div class="p-3" [ngClass]="(showFieldDay(broadcastMessage.BroadcastReceiverType)) ? 'col-4': 'col-6'" *ngIf="showFieldDay(broadcastMessage.BroadcastReceiverType)">
                        <div class="bm-label">Days</div>
                        <input type="number" [(ngModel)]="broadcastMessage.ReceiverDays" pInputText />
                    </div>
                    <div class="p-3" [ngClass]="(showFieldDay(broadcastMessage.BroadcastReceiverType)) ? 'col-4': 'col-6'">
                        <div class="bm-label">Message Type</div>
                        <p-dropdown placeholder="Please Select" [(ngModel)]="broadcastMessage.BroadcastMessageType" [options]="broadcastMessageTypeList"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>

            </p-scrollPanel>

            <div class="bm-gray-line">______________________________________________________________</div>

            <div class="flex justify-content-end mrg-10-0px p-3" *ngIf="!loading">
                <button class="bluedark-btn" pButton label="Next" (click)="activeMenuTab = menuTab.Message"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Message">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 284px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="bm-provide p-2">Please provide some details</div>
   
                <div class="flex flex-row">
                    <div class="col-12 p-3">
                        <div class="bm-label">Title</div>
                        <input type="text" [(ngModel)]="broadcastMessage.MessageTitle" placeholder="Enter message title" pInputText />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-12 p-3">
                        <div class="bm-label">Subtitle</div>
                        <input type="text" [(ngModel)]="broadcastMessage.MessageSubTitle" placeholder="Enter message title" pInputText />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-12 p-3">
                        <div class="bm-label">Image</div>
                        <div *ngIf="broadcastMessage.MessageImageUrl">
                            <img class="bm-message-img"
                                 src="{{broadcastMessage.MessageImageUrl}}" />
                        </div>
                        <div class="bm-upload-file" (click)="handleInputClick('idMessageImgInput')">Upload file</div>
                        <input id="idMessageImgInput"
                               type="file"
                               style="display: none"
                               (change)="handleImageChange($event)" required />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-12 p-3">
                        <div class="bm-label">Body</div>
                        <textarea rows="5" cols="30" [(ngModel)]="broadcastMessage.MessageText" placeholder="Please enter your text here…"
                                  pInputTextarea [autoResize]="true"></textarea>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="bm-gray-line">______________________________________________________________</div>

            <div class="flex justify-content-end mrg-10-0px p-3" *ngIf="!loading">
                <button class="bluedark-btn" pButton label="Create" (click)="createBroadcastMessage()"></button>
            </div>
        </div>

    </div>

    <!--<div class="flex justify-content-end mrg-10-0px p-4" *ngIf="!loading">
        <button class="bluedark-btn" pButton label="Submit" (click)="addOrUpdateDisciplinary()"></button>
    </div>-->

</p-sidebar>
